import { useUserProvider } from '@/context/UserProvider';

const useRegisterOrLoginGuide = () => {
  const { isLogin, onOpenLoginModal, onChangedLoginView } = useUserProvider();

  const guideToRegisterOrLogin = (callback?: () => void) => {
    // 检查是否登录
    if (!isLogin) {
      // 引导用户注册/登录
      onChangedLoginView(false);
      onOpenLoginModal(true);
      return;
    }

    callback?.();
  };

  return {
    isLogin,
    guideToRegisterOrLogin,
  };
};

export default useRegisterOrLoginGuide;
